module.exports = __webpack_public_path__ + "media/images/common/logo-header-b3bb3298b7165492eb47f05a6c754cc2.svg";